import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from './../../../../environments/environment';
import { Observable } from 'rxjs';
import { ActivityBranch } from '../../models/activity-branch.model';

@Injectable({
  providedIn: 'root',
})
export class ActivityBranchService {

  private readonly API = `${environment.api_url}/ramodeatividade`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<ActivityBranch[]> {
    return this.http.get<ActivityBranch[]>(this.API);
  }

  save(body: ActivityBranch): Observable<void> {
    return this.http.post<void>(this.API, body);
  }

  update(body: ActivityBranch): Observable<void> {
    return this.http.put<void>(`${this.API}`, body);
  }

  getBankById(id: string): Observable<ActivityBranch> {
    return this.http.get<ActivityBranch>(`${this.API}/id/${id}`);
  }
}